module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/gbp-7504424fc7ba6eb17279151cd5647a41.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/gbp.svg
// module id = nBZa
// module chunks = 24